import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatErr } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
      nav("/");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left: image with brand overlay */}
      <div className="relative hidden lg:block">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/login-bg.jpg')" }}
        />
        <div className="absolute inset-0 bg-[#1B4776]/90" />
        <div className="relative z-10 h-full flex flex-col p-12">
          {/* Logo: sola yaslı, "MSS Yönetim Sistemi" başlığı genişliğinde, oran korunuyor,
              rengi CSS filter ile saf beyaza dönüştürülüyor. */}
          <img
            src="/mss-logo.png"
            alt="MSS"
            className="h-auto w-[210px] sm:w-[255px]"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <div className="mt-auto">
            <div className="h-[3px] w-16 bg-[#95C11F] mb-6" />
            <div className="text-[11px] uppercase tracking-[0.3em] font-bold text-[#95C11F]">
              MSS Taahhüt İnşaat San. Tic. Ltd. Şti.
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-white tracking-tight font-heading leading-[1.05] mt-4">
              MSS Yönetim
              <br />
              Sistemi
            </h2>
          </div>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-6 sm:p-12 bg-slate-50">
        <Card className="w-full max-w-md p-8 rounded-none sm:rounded-sm border-slate-200 shadow-sm">
          {/* Mobile-only logo (visible when left panel is hidden) */}
          <div className="lg:hidden flex justify-center mb-6">
            <img src="/mss-logo.png" alt="MSS" className="h-12 w-auto" />
          </div>

          <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#8595B4] mb-2">
            Giriş
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-[#1B4776] font-heading mb-1">
            Hoş geldiniz
          </h1>
          <p className="text-sm text-slate-600 mb-8">
            Devam etmek için hesabınıza giriş yapın.
          </p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-widest font-bold text-slate-700">
                E-posta
              </Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]"
              />
            </div>
            <div>
              <Label htmlFor="pw" className="text-xs uppercase tracking-widest font-bold text-slate-700">
                Şifre
              </Label>
              <Input
                id="pw"
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-none sm:rounded-sm focus-visible:ring-[#1B4776]"
              />
            </div>
            <Button
              type="submit"
              data-testid="login-submit"
              disabled={busy}
              className="w-full h-11 rounded-none sm:rounded-sm bg-[#1B4776] hover:bg-[#153859] text-white font-bold tracking-wide"
            >
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
